"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOOGLE_API_KEY = void 0;
const GOOGLE_API_KEY = {
    googleApiKey: 'AIzaSyBmHQS9sLhvZ6sSRfdH_qwRhp-hpkeyKok',
    devGoogleApiKey: 'AIzaSyA8VYHm881itgZ-yQoFvppo5jqv0e4Ol2U',
    recaptchaKey: '6LeB6CwUAAAAALm2usHWVLw8uy6346Pg8n63aRpp',
};
exports.GOOGLE_API_KEY = GOOGLE_API_KEY;
//# sourceMappingURL=google.js.map